import './thread.js';
import './review.js';
import './nomination.js';
import './selection.js';
import './participant.js';
import './presentation.js';

/** Imported for side effects by MJAPI (after mj_generatedentities) and the OEP surface module (T23). */
export function LoadOEPEntityRules(): void {
    // no-op; @RegisterClass runs on import of the modules above
}
